<template>
  <div class="home">
    <progress
      v-if="loggedin && loading"
      class="progress is-medium is-success"
      max="100"></progress>
    <div
      class="tile is-ancestor"
      v-if="me && me.match">
      <div class="tile is-parent">
        <div
          v-if="match && match.id"
          class="tile is-child notification is-success">
          <h2 class="is-size-3 level">My Christmas {{ lastMatch }} Match</h2>
          <profile
            :profile="match" />
        </div>
      </div>
      <div class="tile is-parent">
        <div
          v-if="me && me.id"
          class="tile is-child notification is-light">
          <h2 class="is-size-3 level">
            My Profile
            <router-link
              :to="'/edit'"
              class="button is-small is-info">edit</router-link>
          </h2>
          <profile
            :profile="me"/>
        </div>
      </div>
    </div>
    <div
      v-if="me && me.match"
      class="notification is-info">
      If you think your match's preferences may not be... accurate...
      feel free to contact Mom/Mimi and have her prod your match
      to update their profile. 😉
    </div>
    <section
      v-if="!loggedin"
      class="big-login">
      <button
        class="button is-danger is-large"
        @click="login">LOGIN</button>
    </section>
    <admin
      v-if="me.admin"
      :profile="me"
      class="admin-container" />
  </div>
</template>

<script>
import api from '@/services/api'
import Profile from '@/components/Profile'
import Admin from '@/components/Admin'
import auth from '@/services/AuthService'

export default {
  name: 'home',
  components: {
    Admin,
    Profile
  },
  data () {
    return {
      me: {},
      match: {},
      loggedin: false,
      lastMatch: null,
      loading: false
    }
  },
  mounted () {
    this.loading = true
    this.loggedin = auth.getAuthenticatedFlag()
    Promise.all([
      api.get('/me').then(({ data }) => {
        this.me = data.user
      }),
      api.get('/match').then(({ data }) => {
        this.match = data.user
      }),
      this.getLastMatch()
    ]).then(() => {
      this.loading = false
    })
  },
  methods: {
    login () {
      auth.login()
    },
    getLastMatch () {
      return api.get('/last-match').then(({ data }) => {
        this.lastMatch = data.date
      })
    }
  }
}
</script>

<style lang="scss">
.big-login {
  display: flex;
  height: 75vh;
  align-items: center;
  justify-content: center;
}
</style>
